"use client";

import { SessionProvider, signOut, useSession } from "next-auth/react";
import { useEffect } from "react";

function AuthGuard({ children }: { children: React.ReactNode }) {
    const { data: session } = useSession();

    useEffect(() => {
        // Se c'è un errore di refresh, puliamo tutto immediatamente
        if ((session as any)?.error === "RefreshTokenError") {
            console.error("Sessione corrotta rilevata. Eseguo logout forzato...");
            // redirect: true forza il caricamento della pagina di login
            signOut({ callbackUrl: "/login", redirect: true });
        }
    }, [session]);

    return <>{children}</>;
}

export function Providers({ children }: { children: React.ReactNode }) {
    return (
        <SessionProvider>
            <AuthGuard>
                {children}
            </AuthGuard>
        </SessionProvider>
    );
}